import { useMemo } from "react";
import { useTheme } from "@mui/material";
import { getGridTemplateColumns, getGridTemplateRows } from "../utils/gridUtils";
import { GridLayoutOptions } from "../types";

export const useGridLayout = (options: GridLayoutOptions) => {
    const { columns, rows, spacing, grow, columnWidth } = options;
    const theme = useTheme();

    const colIndices = useMemo(() => Array.from({ length: columns }).map((_, i) => i), [columns]);

    const rowIndices = useMemo(() => Array.from({ length: rows }).map((_, i) => i), [rows]);

    const gapSize = useMemo(() => parseInt(theme.spacing(spacing)), [theme, spacing]);

    const gridTemplateColumns = useMemo(() => getGridTemplateColumns(columns, columnWidth), [columns, columnWidth]);

    const gridTemplateRows = useMemo(() => getGridTemplateRows(rows, grow), [rows, grow]);

    const gridStyle = useMemo(
        () => ({
            display: "grid",
            gridTemplateColumns,
            gridTemplateRows,
            gap: `${gapSize}px`,
            width: "100%",
            minHeight: grow ? "250px" : "auto",
        }),
        [gridTemplateColumns, gridTemplateRows, gapSize, grow],
    );

    return {
        colIndices,
        rowIndices,
        gridStyle,
    };
};
